/**
 * 로그인 후 user 정보 저장함
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

type User = {
  manFstNm: string;
  manSurNm: string;
  manNo: string;
  emlId: string;
  manLodGrpNo: string;
};

interface SetUserState {
  user: User | null;
  setUser: (value: any) => void;
}

const useUserStore = create<SetUserState>()(
  persist(
    (set) => ({
      user: null,

      // 로그인 후 user 값을 저장
      setUser: (value) => {
        set({ user: value });
      },
    }),
    {
      name: "user-storage",
      partialize: (state) => ({
        user: state.user,
      }),
    }
  )
);

export default useUserStore;
